function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray2(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray2(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray2(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray2(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray2(arr); }

function _arrayLikeToArray2(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import React, { useCallback, useEffect, useRef, useState } from 'react';
import DefaultComboboxItem from "./ComboboxItem";
import DefaultComboboxItems from "./ComboboxItems";
import DefaultComboboxSelection from "./ComboboxSelection";
import DefaultComboboxSelections from "./ComboboxSelections";
import DefaultComboboxWrapper from "./ComboboxWrapper";
import DefaultFilteredComboboxItems from "./FilteredComboboxItems";

function isOptionSelected(option, selected) {
  var comparisonKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'value';
  return selected.find(function (selection) {
    return selection[comparisonKey] === option[comparisonKey];
  });
}

function isOptionFiltered(option, filterText) {
  return filterText === '' || option.label.toLowerCase().includes(filterText.toLowerCase());
}

var defaultProps = {
  filterOptions: true,
  initialSelections: [],
  optionComparisonKey: 'value'
};
var defaultComponents = {
  FilteredItems: DefaultFilteredComboboxItems,
  Item: DefaultComboboxItem,
  Items: DefaultComboboxItems,
  Selection: DefaultComboboxSelection,
  Selections: DefaultComboboxSelections,
  Wrapper: DefaultComboboxWrapper
};

function UncontrolledMultiSelectCombobox(_ref) {
  var allowCreation = _ref.allowCreation,
      closeOnSelect = _ref.closeOnSelect,
      components = _ref.components,
      _ref$filterOptions = _ref.filterOptions,
      filterOptions = _ref$filterOptions === void 0 ? defaultProps.filterOptions : _ref$filterOptions,
      _ref$initialSelection = _ref.initialSelections,
      initialSelections = _ref$initialSelection === void 0 ? defaultProps.initialSelections : _ref$initialSelection,
      onCreateOption = _ref.onCreateOption,
      onChange = _ref.onChange,
      options = _ref.options,
      _ref$optionComparison = _ref.optionComparisonKey,
      optionComparisonKey = _ref$optionComparison === void 0 ? defaultProps.optionComparisonKey : _ref$optionComparison;

  var Components = _objectSpread(_objectSpread({}, defaultComponents), components);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  var _useState3 = useState([]),
      _useState4 = _slicedToArray(_useState3, 2),
      visibleOptions = _useState4[0],
      setVisibleOptions = _useState4[1];

  var _useState5 = useState(options.filter(function (option) {
    return initialSelections.includes(option[optionComparisonKey]);
  })),
      _useState6 = _slicedToArray(_useState5, 2),
      selections = _useState6[0],
      setSelections = _useState6[1];

  var _useState7 = useState(''),
      _useState8 = _slicedToArray(_useState7, 2),
      filterText = _useState8[0],
      setFilterText = _useState8[1];

  useEffect(function () {
    var visible = [];
    options.forEach(function (option) {
      if (isOptionFiltered(option, filterText) && !isOptionSelected(option, selections)) {
        visible.push(option);
      }
    });
    setVisibleOptions(visible);
  }, [options, selections, filterText]);
  var canCreateOption = useCallback(function () {
    if (filterText === '' || !allowCreation) {
      return false;
    }

    if (options && options.find(function (option) {
      return option.label.toLowerCase() === filterText.toLowerCase();
    })) {
      return false;
    }

    return true;
  }, [options, filterText, allowCreation]);
  var filterInputRef = useRef(null);

  var handleToggle = function handleToggle() {
    setIsOpen(!isOpen);

    if (!isOpen) {
      setTimeout(function () {
        var _filterInputRef$curre;

        filterInputRef === null || filterInputRef === void 0 ? void 0 : (_filterInputRef$curre = filterInputRef.current) === null || _filterInputRef$curre === void 0 ? void 0 : _filterInputRef$curre.focus();
        setFilterText('');
      }, 10);
    }
  };

  var handleRemoveAll = function handleRemoveAll() {
    setSelections([]);
    setIsOpen(false);
    onChange === null || onChange === void 0 ? void 0 : onChange([]);
  };

  var handleSelectionRemove = function handleSelectionRemove(selection) {
    var newSelections = [];
    selections.forEach(function (current) {
      if (selection[optionComparisonKey] !== current[optionComparisonKey]) {
        newSelections.push(current);
      }
    });
    setSelections(newSelections);
    onChange === null || onChange === void 0 ? void 0 : onChange(newSelections);
    setIsOpen(false);
  };

  var handleFilterChanged = function handleFilterChanged(text) {
    setFilterText(text);
  };

  var handleOptionClicked = function handleOptionClicked(option) {
    var newSelections = _toConsumableArray(selections);

    newSelections.push(option);
    setSelections(newSelections);
    onChange === null || onChange === void 0 ? void 0 : onChange(newSelections);
  };

  var handleCreateOption = function handleCreateOption(optionValue) {
    var newOption = onCreateOption === null || onCreateOption === void 0 ? void 0 : onCreateOption(optionValue);

    if (newOption) {
      handleOptionClicked(newOption);
    }

    setIsOpen(false);
  };

  return /*#__PURE__*/React.createElement(Components.Wrapper, {
    isOpen: isOpen,
    onToggle: handleToggle,
    closeOnSelect: closeOnSelect
  }, /*#__PURE__*/React.createElement(Components.Selections, {
    onRemoveAll: handleRemoveAll
  }, selections.map(function (selection) {
    return /*#__PURE__*/React.createElement(Components.Selection, {
      key: selection[optionComparisonKey],
      onRemove: function onRemove() {
        return handleSelectionRemove(selection);
      }
    }, selection.label);
  })), filterOptions ? /*#__PURE__*/React.createElement(Components.FilteredItems, {
    allowCreation: canCreateOption(),
    filterValue: filterText,
    filterInputRef: filterInputRef,
    onCreateClick: handleCreateOption,
    onFilterChange: handleFilterChanged
  }, visibleOptions.map(function (option) {
    return /*#__PURE__*/React.createElement(Components.Item, {
      key: option[optionComparisonKey],
      onClick: function onClick() {
        return handleOptionClicked(option);
      }
    }, option.label);
  })) : /*#__PURE__*/React.createElement(Components.Items, null, visibleOptions.map(function (option) {
    return /*#__PURE__*/React.createElement(Components.Item, {
      key: option[optionComparisonKey],
      onClick: function onClick() {
        return handleOptionClicked(option);
      }
    }, option.label);
  })));
}

UncontrolledMultiSelectCombobox.displayName = "UncontrolledMultiSelectCombobox";
export default UncontrolledMultiSelectCombobox;